import { useTranslation } from 'react-i18next';
import { Icon, Page } from '@/components';
import { AddProjectButton, ProjectsListPanel } from '@/views/Projects.List';
import {
  CommunityState,
  useGetAvailableCommunitiesForProjectsListQuery,
  useUserContextSelector,
} from '@/redux';
import { useClientSelectPanel } from '@/views';
import { array } from '@/utils';

export function ProjectListPage() {
  const { t } = useTranslation();
  const title = t('projects.title');

  const [currentUserClientId, isAdmin, adminClientId] = useUserContextSelector(
    (x) => [x.clientId, x.isAdmin, x.adminClientId],
  );

  const listPanelState = useClientSelectPanel();
  const { selected: selectedClientId } = listPanelState;

  const { data: communities = array.empty<CommunityState>() } =
    useGetAvailableCommunitiesForProjectsListQuery(
      {
        clientId: adminClientId,
      },
      { skip: !isAdmin },
    );

  return (
    <Page htmlTitle={title}>
      <Page.Paths>
        <Page.Path>{title}</Page.Path>
      </Page.Paths>

      <Page.Body>
        <Page.Card
          title={title}
          icon={<Icon type="inbox" />}
          color="#1FB197"
          actions={
            (isAdmin || communities.length > 0) && (
              <AddProjectButton clientId={selectedClientId || adminClientId} />
            )
          }
        >
          <ProjectsListPanel
            clientId={selectedClientId || currentUserClientId}
          />
        </Page.Card>
      </Page.Body>
    </Page>
  );
}
